import { render, staticRenderFns } from "./indicatorLight1.vue?vue&type=template&id=3b55aa41&scoped=true"
import script from "./indicatorLight1.vue?vue&type=script&lang=js"
export * from "./indicatorLight1.vue?vue&type=script&lang=js"
import style0 from "./indicatorLight1.vue?vue&type=style&index=0&id=3b55aa41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b55aa41",
  null
  
)

export default component.exports